import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";

export default class InsetGallery extends Component {
	
	constructor(props) {
    	super(props);
    	this.state = {
			index : 0,
			open : 	false
			
		}
		this.handleGoTo 	= this.handleGoTo.bind(this);
    }
    
    handleGoTo(_evt) {
	    _evt.preventDefault();  
	    console.log('boom: ' + _evt.currentTarget.getAttribute('data-index'));
	    this.slider.slickGoTo(_evt.currentTarget.getAttribute('data-index'), false);
    }
    
    
  			
	render() {
		
		let gallery = this.props.gallery;
		let heading= this.props.heading;
		let controls = this.props.controls;
		
		if (gallery) {
	    	const settings = {
				dots: 			false,
				arrows: 		false,
				infinite: 		true,
				speed: 			0,
				slidesToScroll: 1,
				centerMode: 	false,
				variableWidth: 	false,
				beforeChange: 	(current, next) => this.setState({ index:next })
			};
			
			return (				
				
				<div className="c-inset-gallery">
					<div className={'c-inset-gallery__inner'}>
						<div className={'c-inset-gallery__wrapper scope-slick scope-slick--' + gallery.length}>
							<Slider ref={slider => (this.slider = slider)} {...settings}>
								{gallery.map((slide,i) =>
									{
										return (
											<div className={'inner ' + slide.fitting} key={i}>							
												<FadeIn>
													{onload => (
														<img
															alt={''} 
															src={slide.src} 
															srcSet={slide.srcset} 
															onLoad={onload}
														/>
													)}
												</FadeIn>
											</div>
										)
									}
								)}
							</Slider>
						</div>
						<div className="c-inset-gallery__footer">
							<div className="c-inset-gallery__footer__inner">
								{controls == 'true' &&
									<div className="c-inset-gallery__footer__controls">
										{gallery.map((slide,i) =>
											{
												let letter = 'A';
												if (i === 1) {
													letter = 'B';
												} else if (i === 2) {
													letter = 'C';
												} else if (i === 3) {
													letter = 'D';
												} else if (i === 4) {
													letter = 'E';
												} else if (i === 5) {
													letter = 'F';
												} else if (i === 6) {
													letter = 'G';
												} else if (i === 7) {
													letter = 'H';
												} else if (i === 8) {
													letter = 'I';
												} else if (i === 9) {
													letter = 'J';
												} else if (i === 10) {
													letter = 'K';
												}
												
												if (this.state.index === i) {
													return (
														<a href="#" className="c-inset-gallery__footer__controls__item state-active" key={i} data-index={i} dangerouslySetInnerHTML={{__html:letter + '.'}} onClick={this.handleGoTo}></a>
													)
												} else {
													return (
														<a href="#" className="c-inset-gallery__footer__controls__item" key={i} data-index={i} dangerouslySetInnerHTML={{__html:letter + '.'}} onClick={this.handleGoTo}></a>
													)
												}
											}
										)}
									</div>
								}
							</div>
						</div>
					</div>	
					
					<ol className="c-inset-gallery__list">
					
						{gallery.map((slide,i) =>
							{
								let letter = 'A';
								if (i === 1) {
									letter = 'B';
								} else if (i === 2) {
									letter = 'C';
								} else if (i === 3) {
									letter = 'D';
								} else if (i === 4) {
									letter = 'E';
								} else if (i === 5) {
									letter = 'F';
								} else if (i === 6) {
									letter = 'G';
								} else if (i === 7) {
									letter = 'H';
								} else if (i === 8) {
									letter = 'I';
								} else if (i === 9) {
									letter = 'J';
								} else if (i === 10) {
									letter = 'K';
								}
								return (
									<li className="c-inset-gallery__list__item" key={i} data-index={i} dangerouslySetInnerHTML={{__html:'<span>' + letter + '.</span>' + slide.caption}} onClick={this.handleGoTo}></li>
								)
							}
						)}
					</ol>
				</div>			
									
			);
			
		} else {
			return null;
		}
	}
}